module.exports = {
	"articleTitle1": "Ruth's Chris Steak House football game promotion: more sizzle than ...",
	"catImage": "greenstar.png",
	"totalCats": 1,
	"name": "Ruth's Chris Steakhosue",
	"articleLink1": "#",
	"articleLink2": "https://www.michigandaily.com/section/news-briefs/daily-harbaugh-chain-gang",
	"articleSnippet1": "Oct 9, 2016 ... The University of Michigan football team's 78-point win against Rutgers may also \nblow out the budget of Ruth's Chris Steak House in Ann Arbor, ...",
	"articleSnippet2": "Oct 18, 2016 ... “The chain gang needed a guy and I was promised a tri-tip steak ... wife Sarah on \ntwitter at Ruth's Chris Steak House in Ann Arbor last week, ...",
	"foodRecommendations": [],
	"articleTitle2": "On the Daily: Harbaugh joins chain gang ",
	"address": "314 S 4th Ave, Ann Arbor, MI 48104",
	"images": [],
	"position": {
		"lat": 42.279008,
		"lng": -83.747734
	},
	"totalMisc": 0,
	"categories": {
		"fooddrink": 1,
		"location": 1,
		"restaurant": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/ruthschris.json
// module id = 964
// module chunks = 0